import "./index.less";
import * as React from "react";

export interface IReportLegendContainerProps {
    children: any;
}
export const ReportLegendContainer: React.FC<IReportLegendContainerProps> = ({
    children,
}: IReportLegendContainerProps) => {
    return <div className="ReportLegendContainer">{children}</div>;
};
